/**
 * A function to create a log object for the 'loyaltyUouCheckoutLogin' event (evid: 1100)
 *
 * Event description: UoU login click from Loyalty checkout plugin
 *
 * @param {loyaltyUouCheckoutLoginParams} params - The parameters for this event
 * @return {LogObject<loyaltyUouCheckoutLoginParams>} LogObject<loyaltyUouCheckoutLoginParams>
 */
export function loyaltyUouCheckoutLogin(params) {
    return { evid: 1100, src: 136, endpoint: 'loyalty-checkout-uou', params: params };
}
/**
 * A function to create a log object for the 'loyaltyUouCheckoutGetReward' event (evid: 1101)
 *
 * Event description: UoU Get Reward click from Loyalty checkout plugin
 *
 * @param {loyaltyUouCheckoutGetRewardParams} params - The parameters for this event
 * @property {number} points - Number of loyalty points to redeem
 * @return {LogObject<loyaltyUouCheckoutGetRewardParams>} LogObject<loyaltyUouCheckoutGetRewardParams>
 */
export function loyaltyUouCheckoutGetReward(params) {
    return { evid: 1101, src: 136, endpoint: 'loyalty-checkout-uou', params: params };
}
/**
 * A function to create a log object for the 'loyaltyUouCheckoutClicks' event (evid: 1102)
 *
 * Event description: Radio button navigation log
 *
 * @param {loyaltyUouCheckoutClicksParams} params - The parameters for this event
 * @property {string} couponDropdown - value selected from dropdown
 * @property {string} click - clicked field - flexible/fixed
 * @return {LogObject<loyaltyUouCheckoutClicksParams>} LogObject<loyaltyUouCheckoutClicksParams>
 */
export function loyaltyUouCheckoutClicks(params) {
    return { evid: 1102, src: 136, endpoint: 'loyalty-checkout-uou', params: params };
}
/**
 * A function to create a log object for the 'loyaltyUouApplyRewardClick' event (evid: 504)
 *
 * Event description: UoU clicks Apply Reward or redeems a coupon
 *
 * @param {loyaltyUouApplyRewardClickParams} params - The parameters for this event
 * @property {string} referralInfo - where click came from
 * @property {string} availableRewards - list of reward_id (guids) that are available
 * @property {string} unavailableRewards - list of reward_id (guids) that are unavailable
 * @property {GUID} rewardId - reward id
 * @property {string} rewardType - reward type
 * @property {number} totalRewards - number of total rewards user can see
 * @property {number} totalPoints - number of points user has
 * @property {string} rewardName - reward name that was used
 * @return {LogObject<loyaltyUouApplyRewardClickParams>} LogObject<loyaltyUouApplyRewardClickParams>
 */
export function loyaltyUouApplyRewardClick(params) {
    return { evid: 504, src: 136, endpoint: 'loyalty-checkout-uou', params: params };
}
/**
 * A function to create a log object for the 'loyaltyUouBuyCoupon' event (evid: 506)
 *
 * Event description: UoU clicks for buying coupons/rewards
 *
 * @param {loyaltyUouBuyCouponParams} params - The parameters for this event
 * @property {string} referralInfo - where click came from - send checkout
 * @property {string} availableRewards - list of reward_id (guids) that are available
 * @property {string} unavailableRewards - list of reward_id (guids) that are unavailable
 * @property {number} rewardPrice - reward price in points
 * @property {GUID} rewardId - reward id
 * @property {string} rewardType - reward type
 * @property {number} totalRewards - number of total rewards user can see
 * @property {number} totalPoints - number of points user has before buying
 * @property {string} rewardName - reward name that was used
 * @return {LogObject<loyaltyUouBuyCouponParams>} LogObject<loyaltyUouBuyCouponParams>
 */
export function loyaltyUouBuyCoupon(params) {
    return { evid: 506, src: 136, endpoint: 'loyalty-checkout-uou', params: params };
}
//# sourceMappingURL=index.js.map